import { XStack } from "tamagui";
import { Spinner } from "./Spinner";
import { Paragraph } from "./Typography";
export const LoadMoreIndicator = ({
  fetchingMore,
  endReached,
  noMoreMessage
}: {
  fetchingMore: boolean;
  endReached: boolean;
  noMoreMessage: string;
}) => {
  return <XStack justifyContent="center" alignItems="center" py="$2" height="$4" data-sentry-element="XStack" data-sentry-component="LoadMoreIndicator" data-sentry-source-file="LoadMoreIndicator.tsx">
      <Spinner position="absolute" transition="bouncy" transform={[{
      scale: fetchingMore ? 1 : 0
    }]} data-sentry-element="Spinner" data-sentry-source-file="LoadMoreIndicator.tsx" />
      <Paragraph position="absolute" transition="100ms easeOut" opacity={endReached && !fetchingMore ? 1 : 0} transform={[{
      scale: endReached && !fetchingMore ? 1 : 0.5
    }]} data-sentry-element="Paragraph" data-sentry-source-file="LoadMoreIndicator.tsx">
        {noMoreMessage}
      </Paragraph>
    </XStack>;
};